// extracted by mini-css-extract-plugin
module.exports = {"Scroll":"Scroll_Scroll__2DPsZ","ScrollX":"Scroll_ScrollX__3s2ev","ScrollY":"Scroll_ScrollY__eBx5e"};